import type { Character, Location, Plot, Project, Scene } from './entities';

export const QUILL_PROJECT_FORMAT = 'quill-studio-project' as const;
export const QUILL_PROJECT_VERSION = 1 as const;

export type PortableEntity<T> = T & Record<string, unknown>;

export interface QuillProjectAsset {
   ownerType: 'character' | 'location';
   ownerId: string;
   attachmentId: string;
   contentType: string;
   data: string;
}

export interface QuillProjectFile {
   format: typeof QUILL_PROJECT_FORMAT;
   version: typeof QUILL_PROJECT_VERSION;
   exportedAt: string;
   project: PortableEntity<Project>;
   scenes: PortableEntity<Scene>[];
   characters: PortableEntity<Character>[];
   locations: PortableEntity<Location>[];
   plots: PortableEntity<Plot>[];
   assets: QuillProjectAsset[];
}

export type ProjectFileExportResult =
   | { canceled: true }
   | { canceled: false; filePath: string }
   | { canceled: false; error: string };

export type ProjectFileImportResult =
   | { canceled: true }
   | { canceled: false; filePath: string; data: QuillProjectFile }
   | { canceled: false; error: string };
